import request from '../utils/request';
import GlobalParameters from '../utils/globalParameters';

export async function getCategoryList() {
    return request(`${GlobalParameters.website}/api/erams/category/list`, {method: 'get'});
}